import React from 'react';
import Head from '../layout/head.jsx'
import Content from '../layout/content.jsx'
import Form from '../layout/form.jsx'
import Loader from '../layout/loader.jsx'
import { toast } from 'react-toastify'
import API from '../../services/api.jsx'
import Helpers from '../../services/helpers.jsx';
import DB from '../../services/db.jsx';

class PlaylistNew extends React.Component {
	constructor(props) {
		super(props)

		const fields = {
			name: { label: 'Name', type: 'text', required: true },
			type: {
				label: 'Playlist type',
				type: 'select',
				options: Helpers.getPlaylistTypeOptions()
			},
			tag: { label: 'Tag', type: 'text', required: false },
		};
		fields.affiliates = {
      label: 'Assigned affiliate(s)',
      type: 'select-multi',
      optionKey: 'affiliates',
      fullWidth: true,
      required: false,
      options: [],
      hidden:
        (Helpers.isSuperAdmin() || Helpers.checkPermissions('playlists:edit')
          ? false
          : true) || DB.get('user').affiliates.length === 1,
    };

		this.state = {
			loading: false,
			breadcrumb: {title: 'Back to playlists', path: '/assets/playlists'},
			fields,
			entity: {
				name: null,
				type: Helpers.isSuperAdmin() ? 'vox' : 'affiliate',
			}
		}
		this.saveEntity = this.saveEntity.bind(this)
	}

	saveEntity(fields) {
		this.setState({ loading: true })
		fields.assets = []
		API.create('playlists', fields).then(() => {
			toast.success('Playlist has been created')
			this.props.history.push('/assets/playlists')
		}).catch(() => {
			// toast.error('An unexpected error has occured, please try again')
			this.setState({ loading: false })
		})
	}

	render() {
		if(this.state.loading)
			return <Loader />
		else
			return <>
				<Head title={'New playlist'} breadcrumb={this.state.breadcrumb} />
				<Content>
					<Form fields={this.state.fields} cancel={() => this.props.history.push('/assets/playlists')} save={this.saveEntity} entity={this.state.entity} />
				</Content>
			</>
	}
}

export default PlaylistNew;
